// Gatsby requirements
import React, { useState } from "react"
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import RichTextRenderer from 'utils/richTextRenderer'

// Styles
import * as CSS from './sectionContactForm.module.scss'

const SectionContactForm = ({ blok, currentPage, en }) => {

    const [state, setState] = React.useState({})

    const [isFeedback, setFeedback] = useState(false)

    const [formSubmitted, setFormSubmitted] = useState(false)

    const handleChange = (e) => {
      setState({ ...state, [e.target.name]: e.target.value })
    }

    function encode(data) {
        return Object.keys(data)
          .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
          .join('&')
    }
  
    const handleSubmit = (e) => {
      e.preventDefault()
      const form = e.target
      fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: encode({
          'form-name': form.getAttribute('name'),
          ...state,
          'Feedback': isFeedback !== false ? isFeedback : '',
        }),
      })
        .then(() => setFormSubmitted(true))
        .catch((error) => alert(error))
    }

    return (
        <section
            className={CSS.section}
            id={blok.anchorId}
            style={{ backgroundColor: blok.backgroundColor }}
            {...storyblokEditable(blok)}
        >

            <div className="wrapper">
                {blok.richtext && blok.richtext.content[0].length > 1 &&
                    <div className={CSS.richtext}>
                        <RichTextRenderer data={blok.richtext} />
                    </div>
                }

                <div className={CSS.wrapper}>

                    {blok.textOnLeft && 
                        <div className={CSS.textOnLeft}>
                            <RichTextRenderer data={blok.textOnLeft} />
                        </div>
                    }

                    <div style={{maxWidth: blok.limitMaxWidth === true ? '54em' : '100%'}} className={CSS.form}>

                        {blok.textBeforeForm &&
                            <RichTextRenderer data={blok.textBeforeForm} />
                        }

                        <form
                            name={currentPage}
                            method="POST"
                            data-netlify="true"
                            data-netlify-honeypot="bot-field"
                            onSubmit={handleSubmit}
                        >

                            <input type="hidden" name="form-name" value="contact" />
                            <p hidden>
                                <label>
                                    Don’t fill this out: <input name="bot-field" onChange={handleChange} />
                                </label>
                            </p>

                            {blok.enableFeedbackSmileys === true &&
                                <div className={CSS.feedback}>
                                    <div>
                                        <input id={blok._uid + '-tevreden'} type="radio" name="feedback" value="tevreden" />
                                        <label for={blok._uid + '-tevreden'} onClick={() => setFeedback('[feedback]: Ja')} aria-label="tevreden" className={CSS.positive}>Ja</label>
                                    </div>
                                    <div>
                                        <input id={blok._uid + '-neutraal'} type="radio" name="feedback" value="neutraal" />
                                        <label for={blok._uid + '-neutraal'} onClick={() => setFeedback('[feedback]: Kan beter')} aria-label="neutraal" className={CSS.neutral}>Kan beter</label>
                                    </div>
                                    <div>
                                        <input id={blok._uid + '-ontevreden'} type="radio" name="feedback" value="ontevreden" />
                                        <label for={blok._uid + '-ontevreden'} onClick={() => setFeedback('[feedback]: Nee')} aria-label="ontevreden" className={CSS.negative}>Nee</label>
                                    </div>
                                </div>
                            }

                            <div className={CSS.flex}>
                                <div>
                                    <label for="name">{en === true ? 'Name:' : 'Uw naam:'}</label>
                                    <input onChange={handleChange} type="text" id="name" name="name" required />
                                </div>
                               
                                <div>
                                    <label for="email">{en === true ? 'Email:' : 'Uw emailadres:'}</label>
                                    <input onChange={handleChange} type="email" id="email" name="email" required />
                                </div>
                            </div>

                            <label for="message">{en === true ? 'Message:' : 'Uw bericht of ervaring:'}</label>
                            <textarea onChange={handleChange} id="message" name="message" required />

                            <button className="button" type="submit" name="submit">{en === true ? 'Send' : 'Versturen'}</button>
                        </form>
                        <p id="form-success" style={{display: formSubmitted === true ? 'block' : 'none'}} className={CSS.success}>{en === true ? 'Successfully sent!' : 'Bedankt, het bericht is verzonden.'}</p>
                    </div>

                </div>

            </div>

        </section>
    )
}

export default SectionContactForm